import React, { forwardRef } from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { Row } from '../../../atoms/row/Row';
import Accordion from '../../../atoms/accordion/Accordion';
import colors from '../../../../../tailwind.colors';
import { Checked } from '../../../../../static/icons/checked';
import { PlusCircleIcon } from '../../../../../static/icons/iconPlusCircle';
import { Tooltip } from '../../../atoms/tooltip/Tooltip';

const AccordionSection = forwardRef(({ section, t }, ref) => (
  <div
    ref={ref}
    className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-10 md:my-20 max-w-6xl"
  >
    <div className="flex flex-col flex-1 gap-10 md:gap-3 py-5 items-center">
      <Stack className="w-full">
        <Typography as="h2" fontVariant="h4">
          {section.title}
        </Typography>
        <Stack className="w-full">
          {section.componentData.map((el) => {
            const halfLength = Math.ceil(el.items.length / 2);
            const firstHalf = el.items.slice(0, halfLength);
            const secondHalf = el.items.slice(halfLength);
            return (
              <Accordion
                key={`${section.title}-${el.title}`}
                title={el.title}
                titleVariant="h7"
                iconColor={colors.primary[500]}
                iconSize={27}
              >
                <div className="flex flex-col md:flex-row flex-1 w-full gap-4 md:gap-20 py-2">
                  <Stack className="gap-4 flex-1">
                    {firstHalf.map((item) => (
                      <Row
                        key={`${section.title}-${el.title}-${item.text}`}
                        className="justify-between"
                      >
                        <Typography
                          textAlign="left"
                          fontVariant="md"
                          className="font-medium"
                        >
                          {item.text}
                        </Typography>
                        {item.value === 'YES' ? (
                          <Tooltip
                            description={t('compare.included')}
                            direction="left"
                          >
                            <Checked />
                          </Tooltip>
                        ) : null}

                        {item.value === 'ADD' ? (
                          <Tooltip
                            description={t('compare.canBeAdded')}
                            direction="left"
                          >
                            <PlusCircleIcon color="#FEC84B" iconSize={27} />
                          </Tooltip>
                        ) : null}

                        {item.value !== 'YES' && item.value !== 'ADD' ? (
                          <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
                        ) : null}
                      </Row>
                    ))}
                  </Stack>
                  <Stack className="gap-4 flex-1">
                    {secondHalf.map((item) => (
                      <Row
                        key={`${section.title}-${el.title}-${item.text}`}
                        className="justify-between"
                      >
                        <Typography
                          textAlign="left"
                          fontVariant="md"
                          className="font-medium"
                        >
                          {item.text}
                        </Typography>

                        {item.value === 'YES' ? (
                          <Tooltip
                            description={t('compare.included')}
                            direction="left"
                          >
                            <Checked />
                          </Tooltip>
                        ) : null}

                        {item.value === 'ADD' ? (
                          <Tooltip
                            description={t('compare.canBeAdded')}
                            direction="left"
                          >
                            <PlusCircleIcon color="#FEC84B" iconSize={27} />
                          </Tooltip>
                        ) : null}

                        {item.value !== 'YES' && item.value !== 'ADD' ? (
                          <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
                        ) : null}
                      </Row>
                    ))}
                  </Stack>
                </div>
              </Accordion>
            );
          })}
        </Stack>
      </Stack>
    </div>
  </div>
));

export default AccordionSection;
